import { ConfirmInputModal, ActionCard } from "shared/components";
import { Trash } from "iconoir-react";
import { Text } from "@ttc3k/trekker";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useOperatorContext } from "apps/directory/Operator";
import { getMultilingualString } from "shared/utils";
import { useBackOffice } from "apps/directory/Operator/views/BackOffice/useBackOffice.ts";
import { useNavigate, useParams } from "react-router-dom";

export const DeleteCard = () => {
  const { t } = useTranslation();
  const { operatorEntityId, organizationId } = useParams();
  const navigate = useNavigate();
  const { operator } = useOperatorContext();
  const { onDeleteOperator, loadingDeleteOperator } = useBackOffice(
    operator,
    operatorEntityId,
    organizationId,
  );

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const handleSetIsModalOpen = () => {
    setIsDeleteModalOpen(!isDeleteModalOpen);
  };

  const handleDeleteComplete = () => {
    handleSetIsModalOpen();
    /**
     *  Allow time for refetchQuery and subsequent onCompleted from `operatorMany` to run
     *  Because we're switching pages, the `onCompleted` function won't run unless we are
     *  still on the same operator page
     */
    setTimeout(
      () => navigate(`/app/organization/${organizationId}/directory`),
      500,
    );
  };

  return (
    <>
      <ActionCard
        title={t(
          `directory:OPERATOR.BACK_OFFICE.VISIBILITY_STATUS.DELETE.TITLE`,
        )}
        subText={t(
          `directory:OPERATOR.BACK_OFFICE.VISIBILITY_STATUS.DELETE.DESCRIPTION`,
        )}
        buttonProps={{
          visual: "destructive",
          children:
            t(
              `directory:OPERATOR.BACK_OFFICE.VISIBILITY_STATUS.DELETE.BUTTON_TEXT`,
            ) + "...",
          onClick: handleSetIsModalOpen,
        }}
        surfaceProps={{ borderColor: "border.error" }}
        bodyProps={{ bg: "bg.error.lightest" }}
        textProps={{ color: "text.error.dark" }}
      />
      <ConfirmInputModal
        isOpen={isDeleteModalOpen}
        onClose={handleSetIsModalOpen}
        title={t(
          `directory:OPERATOR.BACK_OFFICE.VISIBILITY_STATUS.DELETE.TITLE`,
        )}
        HeaderIcon={Trash}
        cancelButtonProps={{
          onClick: handleSetIsModalOpen,
        }}
        saveButtonCopy={t(
          `directory:OPERATOR.BACK_OFFICE.VISIBILITY_STATUS.DELETE.BUTTON_TEXT`,
        )}
        saveButtonProps={{
          visual: "destructive",
          isLoading: loadingDeleteOperator,
          onClick: () => onDeleteOperator(handleDeleteComplete),
        }}
        textToConfirm={getMultilingualString(operator.name)}
      >
        <Text color={"text.mid"}>
          {t(
            "directory:OPERATOR.BACK_OFFICE.VISIBILITY_STATUS.DELETE.DESCRIPTION",
          )}
        </Text>
      </ConfirmInputModal>
    </>
  );
};
